// extracted by mini-css-extract-plugin
export default {"anchor":"IconButtonSelector-module__anchor--t8Bzw"};